import Fallback from './SiteCreate.fallback';
import { routeEntry } from '../route-utils';

export default routeEntry({
  fallback: <Fallback />,
  component: () => import('./SiteCreate.page'),
});
